export default __webpack_public_path__ + "static/media/2.c7e4a076.webp";